import type {Logger} from "../logging.ts";

export type LicenseValidatorOptions = {
    validationKey: string;
    logger?: Logger
}

export type LicenseValidationOptions = {
    logSuccessMessages?: boolean
};

export type LicensePayload = {
    "type": "paid" | "trial";
    "expiration": number // in milliseconds
    "email": string,
    "issuedBy": string;
    "iat": number; // in seconds
    "licensee": string;
    "organization": {
        "displayName": string,
        "identifier": string
    }
}

export type LicenseEvaluationResult = {
    licenseType: 'paid' | 'trial' | 'none';
    expired: boolean;
    fatal: boolean;
    license?: LicensePayload;
    error?: string;
}


export const licenseValidationResults = {
    TRIAL_LICENSE_EXPIRED: {licenseType: 'trial', expired: true, fatal: true} as LicenseEvaluationResult,
    TRIAL_LICENSE_VALID: {licenseType: 'trial', expired: false, fatal: false} as LicenseEvaluationResult,
    PAID_LICENSE_EXPIRED: {licenseType: 'paid', expired: true, fatal: false} as LicenseEvaluationResult,
    PAID_LICENSE_VALID: {licenseType: 'paid', expired: false, fatal: false} as LicenseEvaluationResult,
    NO_LICENSE: {licenseType: 'none', expired: false, fatal: true} as LicenseEvaluationResult,
};